<!--Convert Count Result 弹窗-->
<template>
    <a-modal
            :title="$t('convertCountResult.title')"
            v-model="visible"
            width="60%"
            :footer="null"
            :maskClosable="false"
            @cancel="cancel"
    >
        <!--Filename start from-->
        <a-row type="flex" align="middle" style="margin-bottom: 8px;">
            <a-col :span="4" style="text-align: right; padding-right: 8px;">
                {{ $t('convertCountResult.filenameStartFrom') }}:
            </a-col>
            <a-col :span="14">
                <a-input
                        size="small"
                        v-model="filename"
                        :placeholder="$t('convertCountResult.filenameStartFrom')"
                        allow-clear
                />
            </a-col>
        </a-row>

        <!--Upload (placed directly below the input, right-aligned with the input's right edge)-->
        <a-row type="flex" style="margin-bottom: 16px;">
            <a-col :span="14" :offset="4" style="text-align: right;">
                <a-upload
                        :show-upload-list="false"
                        :before-upload="handleBeforeUpload"
                        accept=".xlsx"
                >
                    <a-button size="small" type="primary" @click="handleUploadClick">{{ $t('publicLang.Upload') }}</a-button>
                </a-upload>
            </a-col>
        </a-row>

        <a-divider style="margin: 8px 0;"/>

        <!--Import result info-->
        <a-row v-if="result.refNum">
            <a-col :span="24">
                <div class="result-line">Ref Num: {{ result.refNum }}</div>
                <div class="result-line">Start Time: {{ result.startTime }}</div>
                <div class="result-line">Complete Time: {{ result.completeTime }}</div>
            </a-col>
        </a-row>

        <a-divider style="margin: 8px 0;"/>

        <!--Import status + Download (only shown after a successful upload)-->
        <a-row v-if="result.success" type="flex" align="middle" justify="space-between">
            <a-col>
                <span :class="['status-text', 'status-success']">
                    {{ $t('convertCountResult.importSuccess') }}
                </span>
            </a-col>
            <a-col>
                <a-button
                        size="small"
                        type="primary"
                        @click="downloadResult"
                >{{ $t('publicLang.Download') }}</a-button>
            </a-col>
        </a-row>
    </a-modal>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import axios from "axios";
    import cookie from "../../../api/cookie";
    export default {
        data() {
            return {
                visible: false,
                filename: "",
                result: {
                    refNum: "",
                    startTime: "",
                    completeTime: "",
                    success: false,
                    fileId: "",
                    downloadPath:"",
                }
            };
        },
        methods: {
            show() {
                this.visible = true;
                this.reset();
            },
            cancel() {
                this.reset();
                this.visible = false;
            },
            reset() {
                this.filename = "";
                this.result = {
                    refNum: "",
                    startTime: "",
                    completeTime: "",
                    success: false,
                    fileId: "",
                    downloadPath:"",
                };
            },
            handleUploadClick(e) {
                if (!["2", "S", "Q"].includes(this.filename)) {
                    this.$customMessage.warning(this.$t("convertCountResult.invalidFilename"));
                    this.filename = "";
                    // Block the upload button from triggering the file picker
                    e && e.stopPropagation && e.stopPropagation();
                    e && e.preventDefault && e.preventDefault();
                    return false;
                }
            },
            handleBeforeUpload(file) {
                const fileExt = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
                if (fileExt !== ".xlsx") {
                    this.$customMessage.warning(this.$t("convertCountResult.invalidFileType"));
                    return false;
                }
                const formData = new FormData();
                formData.append("file", file);
                formData.append("filename", this.filename);
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.post(api.CONVERTCOUNTRESULTUPLOAD, formData).then(res => {
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if (res.code == 200 && res.data) {
                        this.result = {
                            refNum: file.name,
                            startTime: res.data.startTime || "",
                            completeTime: res.data.completeTime || "",
                            success: true,
                            fileId: res.data.fileId || "",
                            downloadPath:res.data.downloadPath || "",
                        };
                    } else {
                        this.$customMessage.warning(res.msg || this.$t("publicLang.UploadFailed"));
                    }
                }).catch(() => {
                    this.$store.commit("updataLoading", { pbLoading: false });
                });
                return false;
            },
            downloadResult() {
                if (!this.result.downloadPath) {
                    this.$customMessage.warning(this.$t("convertCountResult.noFileToDownload"));
                    return;
                }
                const ajaxurl = ajax.ajaxUrl();
                axios.get(ajaxurl + api.CONVERTCOUNTRESULTDOWNLOAD, {
                    params: { downloadPath: this.result.downloadPath},
                    headers: { Authorization: cookie.getBearerToken() },
                    responseType: "blob"
                }).then(res => {
                    const blob = new Blob([res.data], { type: res.headers["content-type"] || "application/zip" });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    let fileName = this.result.refNum || "convertResult";
                    fileName = fileName.replace(/\.xlsx$/i, "");
                    link.download = fileName.toLowerCase().endsWith(".zip") ? fileName : fileName + ".zip";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }).catch(err => {
                    console.error("Download failed:", err);
                    this.$customMessage.warning(this.$t("publicLang.DownloadFailed"));
                });
            }
        }
    };
</script>
<style scoped>
    .result-line {
        line-height: 22px;
        color: #333;
    }
    .status-text {
        font-size: 14px;
    }
    .status-success {
        color: #333;
    }
    .status-default {
        color: #999;
    }
</style>
